import { graphql } from 'react-relay';

export const hometaxBlockSettings = graphql`
  query hometaxBlockSettingsQuery {
    hometaxBlockSettings {
      bypassAuthEnabled
      queueScreenEnabled
      queueScreenStage
      waitingCount
      corpQueueScreenEnabled
      corpWaitingCount
    }
  }
`;

export const hometaxBlockNotificationStatus = graphql`
  query hometaxBlockNotificationStatusQuery($businessType: String!) {
    hometaxBlockNotificationStatus(businessType: $businessType) {
      requested
    }
  }
`;
